import { Record } from "immutable";
import { EventType } from "models/enumerations/events/event-type";
import { SearchSubmittedEvent } from "models/interfaces/events/search-submitted-event";

const defaultValues: SearchSubmittedEvent = {
    type: EventType.SearchSubmitted,
    searchEvent: {
        searchText: "",
        skip: 0,
        take: 0,
        totalCount: 0,
        duration: "",
        origin: "",
        filters: [],
    },
    sessionId: "",
};

export default class SearchSubmittedEventRecord
    extends Record(defaultValues)
    implements SearchSubmittedEvent
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params: Partial<SearchSubmittedEvent> = {}) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    public with(
        values: Partial<SearchSubmittedEvent>
    ): SearchSubmittedEventRecord {
        return new SearchSubmittedEventRecord(
            Object.assign(this.toJS(), values) as SearchSubmittedEvent
        );
    }

    // #endregion Public Methods
}
